const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;

const localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
const nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;

class StringUtil {
  static trimZero(number) {
    if (!number) return "0";
    if (!String(number).includes(".")) return number;
    return String(number).replace(/\.?0+$/, "");
  }

  static toUpperCase(str) {
    if (!str) return;
    return str.toUpperCase();
  }

  static toLowerCase(str) {
    if (!str) return;
    return str.toLowerCase();
  }

  static isUrl(string) {
    if (typeof string !== "string") {
      return false;
    }

    var match = string.match(protocolAndDomainRE);
    if (!match) {
      return false;
    }

    var everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) {
      return false;
    }

    if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) {
      return true;
    }

    return false;
  }

  static serialize(data) {
    if (typeof data == 'string') return data;

    return JSON.stringify(data);
  }

  static toFixed2(number) {
    if (!number) return '0.00';
    let numberString = String(number);

    let dotIdx = numberString.indexOf('.');

    if (dotIdx == -1) {
      return numberString + '.00';
    }

    numberString += '00';

    return numberString.slice(0, dotIdx + 3);
  }

  static formatVersion(version) {
    if (version.includes('.')) {
      return version;
    } else {
      return version + '.0';
    }
  }

}

export default StringUtil;
